import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import editIcon from "../../../../assets/icons/icon-pen-white.svg"
import { ActionTypes } from "../../../../enums/ActionTypes";
import { ActionStyles } from "../../../../enums/ActionStyles";
import { IsBetweenInclusive, IsValidYear, NotEmptyString, NumberGreaterThanOrEqualToZero, NumberGreaterThanZero, ValidateInt } from "../../../../Validation/Validation";
import SidePanelCases from "../../layout/SidePanel/layouts/SidePanelCases";

export const CasesSchema: ISchema = {
    displayName: "Case",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelCases data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'caseMaterialTypeId',
            displayName: 'Type',
            type: PropertyTypes.PackingBoxType,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            entityName: EntityNames.caseMaterialTypes,
            rememberLastFormValue: true
        } as ISchemaProperty,
        {
            name: 'code',
            displayName: 'Case Number',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Case number cannot be empty",
        } as ISchemaProperty,
        {
            name: 'year',
            displayName: 'Year',
            type: PropertyTypes.year,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: IsValidYear as Function,
            validationError: "Please enter valid year",
        } as ISchemaProperty,
        {
            name: 'accountPrefix',
            displayName: '',
            type: PropertyTypes.accountPrefix,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            renderBasedOnParentData: (values, isCreate) => {
                if (!values) {
                    return false;
                }
                return true;
            }
        } as ISchemaProperty,
        {
            name: 'prefix',
            displayName: 'Prefix',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountId',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'materialType',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'notes',
            displayName: 'Notes',
            type: PropertyTypes.textArea,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            autocomplete: "off"
        } as ISchemaProperty,
        {
            name: 'quantity',
            displayName: 'Quantity',
            type: PropertyTypes.quantity,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: ValidateInt as Function,
            validationError: "Please enter a quantity"
        } as ISchemaProperty,
        {
            name: 'specimens',
            displayName: 'Specimens',
            type: PropertyTypes.specimens,
            key: false,
            showInList: false,
            showInForm: false, // We dont want to show this for now, until part case returns approved in phase 2
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty
    ],


    primaryFilter: {
        PropertyName: "Code",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.code,
        placeHolder: "Enter a case number"
    } as ISchemaFilter,


    filters: [
        {
            PropertyName: "prefix",
            displayName: "Prefix",
            type: FilterTypes.search,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.string
        } as ISchemaFilter,
        {
            PropertyName: "AccountId",
            entityName: "accounts",
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "Year",
            displayName: "Year",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterials.CaseMaterialTypeId",
            entityName: "caseMaterialTypes",
            displayName: "Material Type",
            type: FilterTypes.multiSelect,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Contains,
            propertyType: PropertyTypes.guidList
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterials.Status",
            entityName: "caseMaterialStatuses",
            displayName: "Status",
            type: FilterTypes.select,
            required: false,
            className: "small-6",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.CaseMaterialStatus
        } as ISchemaFilter,
        {
            PropertyName: "Notes",
            displayName: "Notes",
            type: FilterTypes.search,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.FreeText,
            propertyType: PropertyTypes.string,
        } as ISchemaFilter,
    ],

    children: [
        { entityName: EntityNames.caseMaterials, displayName: "Contents", cantView: true, viewType: EntityViewTypes.list } as ISchemaChild,
        { entityName: EntityNames.specimens, displayName: "Specimens", viewType: EntityViewTypes.list } as ISchemaChild,
        { entityName: EntityNames.audits, displayName: "Audit Trail", cantView: true, viewType: EntityViewTypes.list } as ISchemaChild,
    ],

    sidePanelActions: [
        { text: "Edit Details", action: ActionTypes.edit, style: ActionStyles.primary, icon: editIcon } as ISchemaAction,
    ]
}
